import { render, staticRenderFns } from "./AssetScrappedDisposedReport.vue?vue&type=template&id=1661ca10&"
import script from "./AssetScrappedDisposedReport.vue?vue&type=script&lang=ts&"
export * from "./AssetScrappedDisposedReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports